"use strict";

exports.__esModule = true;
exports.EmailEditor = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _Core = require("../../Core");
var _FormGroupField = require("../FormGroupField");
var _isValidEmail = require("../../User/isValidEmail");
var _inputValidation = require("../../../Utils/inputValidation");
var _class, _EmailEditor;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var EmailEditor = exports.EmailEditor = (0, _Core.withTranslator)(_class = (_EmailEditor = /*#__PURE__*/function (_Component) {
  function EmailEditor() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    // Delegates to the shared, anchored validator rather than repeating the
    // pattern here. The duplicated copy was unanchored, so a value such as
    // "<img src=q onerror=prompt(8)>a@b.com" was accepted. (VAPT-02)
    _this.validateEmail = function (value, allValues, meta) {
      if (value === void 0) {
        value = "";
      }
      var _this$props = _this.props,
        translator = _this$props.translator,
        isNew = _this$props.isNew;
      var translate = translator.translate;

      // While editing, a stored address the user has not touched is left alone --
      // including an empty one. Rules added after a record was created must not
      // make it unsaveable, since a field-level error disables Save for the whole
      // form. On create there is no stored value, so the address is required.
      if (!isNew && (0, _inputValidation.isUnmodified)(meta)) {
        return undefined;
      }
      return (0, _isValidEmail.isValidEmail)(value) ? undefined : translate("EmailEditor.validateEmail.invalidEmail", "Invalid Email");
    };
    return _this;
  }
  _inheritsLoose(EmailEditor, _Component);
  var _proto = EmailEditor.prototype;
  _proto.render = function render() {
    var _this$props2 = this.props,
      translator = _this$props2.translator,
      _this$props2$disabled = _this$props2.disabled,
      disabled = _this$props2$disabled === void 0 ? false : _this$props2$disabled;
    var translate = translator.translate;
    return /*#__PURE__*/_react["default"].createElement(_FormGroupField.FormGroupField, {
      name: "email",
      label: translate("EmailEditor.label", "Email"),
      requiredLabel: /*#__PURE__*/_react["default"].createElement(_Core.RequiredLabel, null),
      validate: this.validateEmail
    }, function (_ref) {
      var input = _ref.input;
      return /*#__PURE__*/_react["default"].createElement(_core.InputGroup, _extends({
        "data-testid": "email"
      }, input, {
        disabled: disabled
      }));
    });
  };
  return EmailEditor;
}(_react.Component), _EmailEditor.defaultProps = {
  translator: undefined,
  // Consumers that edit an existing record leave this false; the create
  // screens pass true. See validateEmail.
  isNew: false
}, _EmailEditor)) || _class;